__turbopack_context__.v({
  "barForm": "investor-alerts-form-module-scss-module__5d_zka__barForm",
  "barInput": "investor-alerts-form-module-scss-module__5d_zka__barInput",
  "barSubmit": "investor-alerts-form-module-scss-module__5d_zka__barSubmit",
  "feedbackError": "investor-alerts-form-module-scss-module__5d_zka__feedbackError",
  "feedbackSuccess": "investor-alerts-form-module-scss-module__5d_zka__feedbackSuccess",
  "panelEmailRow": "investor-alerts-form-module-scss-module__5d_zka__panelEmailRow",
  "panelForm": "investor-alerts-form-module-scss-module__5d_zka__panelForm",
  "panelInput": "investor-alerts-form-module-scss-module__5d_zka__panelInput",
  "panelLabel": "investor-alerts-form-module-scss-module__5d_zka__panelLabel",
  "panelNameRow": "investor-alerts-form-module-scss-module__5d_zka__panelNameRow",
  "panelSubmit": "investor-alerts-form-module-scss-module__5d_zka__panelSubmit",
});
